var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1523",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 16.667,
    height: 16.667,
    transform: "translate(10.167 13.332)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7538",
    "data-name": "Group 7538",
    transform: "translate(3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, 4)",
    filter: "url(#Path_1523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523-2",
    "data-name": "Path 1523",
    d: "M18.5,35A12.5,12.5,0,1,0,6,22.5,12.5,12.5,0,0,0,18.5,35Z",
    transform: "translate(3 -4)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M19.05,13.973l2,4.252a.629.629,0,0,0,.472.357l4.494.684a.653.653,0,0,1,.349,1.1L23.106,23.7a.661.661,0,0,0-.177.569l.769,4.694a.631.631,0,0,1-.913.68l-4-2.2a.61.61,0,0,0-.59,0l-4,2.2a.631.631,0,0,1-.913-.679l.769-4.694a.662.662,0,0,0-.177-.569L10.6,20.368a.653.653,0,0,1,.349-1.1l4.494-.684a.629.629,0,0,0,.472-.357l2-4.252a.618.618,0,0,1,1.127,0Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M17.389,21.666a.278.278,0,0,1-.278-.278.556.556,0,1,0-1.111,0,.278.278,0,0,1-.556,0,1.111,1.111,0,0,1,2.222,0,.278.278,0,0,1-.278.278Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M21.278,21.666A.278.278,0,0,1,21,21.389a.556.556,0,1,0-1.111,0,.278.278,0,0,1-.556,0,1.111,1.111,0,1,1,2.222,0,.278.278,0,0,1-.278.278Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M18.5,25.276a3.535,3.535,0,0,0,3.1-2.213.278.278,0,0,0-.325-.385,10.446,10.446,0,0,1-5.556,0,.278.278,0,0,0-.325.385A3.534,3.534,0,0,0,18.5,25.276Z",
    fill: "#ecf0f1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.773b143055b816deee9d9f0e1b05c8f3.svg";
export { ForwardRef as ReactComponent };